import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TableAction, TableColumn } from '../../../shared/components/table/table.component';
import { ConfigOrdersService } from '../../../services/config-orders.service';
import { ConfirmationService } from '../../../shared/services/confirmation.service';

@Component({
  selector: 'app-service-order-config',
  templateUrl: './service-order-config.component.html',
  styleUrls: ['./service-order-config.component.css']
})
export class ServiceOrderConfigComponent implements OnInit {

  // Colunas da tabela de configurações de OS (dados fake)
  configOrderColumns: TableColumn[] = [
    { titulo: 'Tipo de OS', label: 'typeOS' },
    { titulo: 'Grupo', label: 'group' },
    { titulo: 'Data de Criação', label: 'createdAt' },
    { titulo: 'Data de Atualização', label: 'updatedAt' }
  ];

  loading = false;
  actions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'fas fa-edit',
      action: 'edit',
      class: 'btn-edit'
    },
    {
      label: 'Excluir',
      icon: 'fas fa-trash',
      action: 'delete',
      class: 'btn-delete'
    }
  ];

  configOrders: Array<{
    id: number;
    typeOS: string;
    group: string;
    createdAt: string | null;
    updatedAt: string | null;
    isActive: boolean | null;
  }> = [];

  constructor(
    private router: Router,
    private configOrdersService: ConfigOrdersService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadConfigOrders();
  }

  private loadConfigOrders(): void {
    this.loading = true;
    this.configOrdersService.getAll().subscribe({
      next: (items) => {
        this.configOrders = (items || []).map(x => ({
          id: x.id,
          typeOS: x.typeOS,
          group: x.group?.name || '',
          createdAt: x.createdAt ?? null,
          updatedAt: x.updatedAt ?? null,
          isActive: x.active ?? null
        }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onAddNewConfig(): void {
    this.router.navigate(['/service-orders/config/new']);
  }

  onRowClick(item: { id: number } | null): void {
    if (!item?.id) return;
    this.router.navigate(['/service-orders/config', item.id, 'edit']);
  }

  onActionClick(event: { action: string; item: any }): void {
    if (event?.action === 'edit') {
      const id = event?.item?.id;
      if (!id) return;
      this.router.navigate(['/service-orders/config', id, 'edit']);
    } else if (event?.action === 'delete') {
      const id = event?.item?.id;
      if (!id) return;
      const typeOS = event?.item?.typeOS || String(id);
      this.confirmationService.confirm({
        title: 'Excluir configuração de OS',
        message: `Ao excluir a configuração "${typeOS}", todas as Ordens de Serviço associadas a ela também serão excluídas. Tem certeza que deseja continuar?`,
        type: 'danger',
        confirmText: 'Excluir',
        cancelText: 'Cancelar',
        confirmButtonClass: 'btn-danger',
        cancelButtonClass: 'btn-secondary'
      }).subscribe(confirmed => {
        if (!confirmed) return;
        this.configOrdersService.delete(id).subscribe({
          next: () => this.loadConfigOrders(),
          error: () => {}
        });
      });
    }
  }

  onSortChange(event: { sortBy: string; sortOrder: 'asc' | 'desc' }): void {
    this.configOrders = [...this.configOrders].sort((a, b) => {
      const va = String((a as any)[event.sortBy] ?? '');
      const vb = String((b as any)[event.sortBy] ?? '');
      const cmp = va.localeCompare(vb, 'pt-BR', { numeric: true });
      return event.sortOrder === 'asc' ? cmp : -cmp;
    });
  }

  onCancel(): void {
    this.router.navigate(['/service-orders']);
  }
}
